export const shouldReduceMotion = () => {
  if (typeof window === 'undefined') {
    return true;
  }

  const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const isTestEnv = process.env.NODE_ENV === 'test';
  const isAutomatedBrowser = Boolean(window.navigator?.webdriver);

  return Boolean(prefersReducedMotion || isTestEnv || isAutomatedBrowser);
};

export default shouldReduceMotion;